import React from 'react';

import { useTranslation } from 'react-i18next';

import { MenuItemsType } from '@/hooks/useViews';

import { NavListContainer } from './NavListContainer';

interface ViewsItemProps {
  views: MenuItemsType;
  dropdownOpen: boolean;
  onMoreClick: () => void;
  isViewsLoading: boolean;
}

/**
 * Memoized ViewsItem component for rendering the views navigation list
 */
export const ViewsItem = React.memo<ViewsItemProps>(
  ({ views, dropdownOpen, onMoreClick, isViewsLoading }) => {
    const { t } = useTranslation();

    return (
      <NavListContainer
        type="views"
        title={t('conversation.views.views')}
        pinnedItems={views}
        hasPermission
        open={dropdownOpen}
        onMoreClick={onMoreClick}
        isLoading={isViewsLoading}
        plusTooltip={t('conversation.views.add_view')}
      />
    );
  }
);

ViewsItem.displayName = 'ViewsItem';
